import React from 'react';
import SingleLocList from './single-loc';
import LocGroup from './location-group';
import DateGroup from './DateGroup';
import TemplateNameGroup from './NameGroup';
import TemplateGroupBox from './template-group-box';
import Pagination from '../../../tc-ui/pagination/pagination';
import R from 'ramda';
import EditGroupDialog from './edit-group-dialog';
import SearchNFilter from './search-filter';
import { CircularProgress } from 'material-ui';
import moment from 'moment';
import PublishDraftDialog
  from '../../contract-activities-products/draftNTemplate-container/publish-draft-dialog';
import ListZeroState from '../../generic-components/zero-state';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const TemplateOrDraftList = ({
  route,
  locations,
  templateGroups,
  templates,
  allContractPeriods,
  currentYear,
  statusesFilter,
  saveNewTemplateName,
  drafts,
  isTourRunning,
  router,
  deleteTemplate,
  archiveUnarchive,
  updateTemplateProps,
  deleteDraft,
  updateDraftProps,
  onExpandChange,
  updateProps,
  updateFilters,
  templateListPage,
  downloadPdfZip,
  showType,
  searchInput,
  searchingAllYears,
  listRefreshing,
  templatesLoaded,
}) => {
  const isSingleLoc = !(locations && locations.filter(loc => loc.name).length > 1);
  // const currentPage = route === 'templates' ? templateListPage : draftListPage;
  // const currentDocs = route === 'templates' ? templates : drafts;
  const currentPage = templateListPage;

  const isDatesMatch = (doc) => {
    return moment(doc.startDate).isBetween(currentYear.startDate, currentYear.endDate, 'day', '[]')
      || moment(doc.endDate).isBetween(currentYear.startDate, currentYear.endDate, 'day', '[]')
      || (moment(doc.startDate).isBefore(currentYear.startDate, 'day') && moment(doc.endDate).isAfter(currentYear.endDate, 'day'));
  };
  const currentDocs = R.call(R.compose(
    R.sort((objA, objB) => {
      if (objA.updatedAt > objB.updatedAt) return -1;
      return 1;
    }),
    R.filter(doc => {
      if (R.isEmpty(statusesFilter)) return !doc.isArchived;
      if (statusesFilter.indexOf('not sent') > -1 && doc.partnersCount === 0) return true;
      return statusesFilter.indexOf(doc.shownStatus) > -1;
    }),
    R.filter(doc => {
      if (searchingAllYears) return true;
      if (!currentYear || R.isEmpty(currentYear)) return true;
      return isDatesMatch(doc, currentYear);
    })
  ), R.concat(templates, drafts));
  const actionFuncs = {
    saveNewTemplateName,
    deleteTemplate,
    updateTemplateProps,
    deleteDraft,
    updateProps,
    updateDraftProps,
    router,
    archiveUnarchive,
  };
  const getContent = () => {
    if (templatesLoaded && R.isEmpty(currentDocs)) {
      return (
        <ListZeroState
          softZero={!searchingAllYears || !R.isEmpty(statusesFilter)}
          title="Welcome to the Rate Templates, where you can manage all of your static rates in one place."
          buttonTitle="Start by creating a rate template"
          buttonList={[
            {
              label: 'Create a Rate Template',
              func: () => router.push(`/contracting/create-template-draft`),
            },
            {
              label: 'Request a Demo',
              func: () => window.open('https://app.hubspot.com/meetings/andrew157'),
            },
          ]}
          videoLink="https://vimeo.com/313071664"
        />
      );
    }
    if (!showType) {
      const processedDocs = searchInput ? currentDocs.filter(R.compose(
        R.test(new RegExp(searchInput, 'i')),
        R.converge(R.concat, [
          doc => (R.prop('templateName', doc) || R.prop('buyerCompanyName', doc) || R.propOr('', 'email', doc)),
          R.propOr('', 'locationName')])
      )) : currentDocs;
      if (searchInput && isNilOrEmpty(processedDocs)) return <div style={{ minHeight: '400px', fontSize: '24px', textAlign: 'center', margin: '50px' }}>There are no files that matches your search.</div>;
      return (
        <div>
          <SingleLocList
            route={route}
            router={router}
            showLocName={!isSingleLoc}
            docs={R.slice((currentPage - 1) * 20, currentPage * 20, processedDocs)}
            {...actionFuncs}
          />
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(processedDocs.length / 20)}
            goToPage={page => updateProps({ [route === 'templates' ? 'templateListPage' : 'draftListPage']: page })}
            noOfPagesToShow={5}
          />
        </div>
      );
    }
    if (showType === 'location') {
      const processedLocs = searchInput ? locations.filter(R.compose(
        R.test(new RegExp(searchInput, 'i')),
        R.propOr('', 'name')
      )) : locations;
      if (searchInput && isNilOrEmpty(processedLocs)) return <div style={{ minHeight: '400px', fontSize: '24px', textAlign: 'center', margin: '50px' }}>There are no files that matches your search.</div>;
      return (
        <div>
          {
            processedLocs.filter(loc => {
              const docs = R.filter(R.propEq('locationId', loc.locationId), currentDocs);
              return !R.isEmpty(docs);
            })
              .map((loc, locIndex) => {
                const docs = R.filter(R.propEq('locationId', loc.locationId), currentDocs);
                return (
                  <LocGroup
                    key={locIndex}
                    docs={docs}
                    locationName={loc.name}
                    expanded={isTourRunning && locIndex === 0 ? true : loc[`${route}Expanded`]}
                    onExpandChange={() => onExpandChange(docs, loc.locationId, `${route}Expanded`, loc[`${route}Expanded`])}
                    actions={actionFuncs}
                  />
                );
              })
          }
        </div>
      );
    }
    if (showType === 'date') {
      return (
        <div>
          {
            allContractPeriods.filter(({ startDate, endDate }) => {
              const docs = R.filter(doc => doc.startDate === startDate && doc.endDate === endDate, currentDocs);
              return !R.isEmpty(docs);
            })
            .map(({ startDate, endDate }, dateIndex) => {
              const docs = R.filter(doc => doc.startDate === startDate && doc.endDate === endDate, currentDocs);
              return (
                <DateGroup
                  key={dateIndex}
                  docs={docs}
                  contractPeriod={{ startDate, endDate }}
                  actions={actionFuncs}
                />
              );
            })
          }
        </div>
      );
    }
    if (showType === 'templateName') {
      const allTemplateNames = R.keys(R.groupBy(R.prop('templateName'), currentDocs));
      return (
        <div>
          {
            allTemplateNames
            .map((templateName, dateIndex) => {
              const docs = R.filter(doc => doc.templateName === templateName, currentDocs);
              return (
                <TemplateNameGroup
                  key={dateIndex}
                  docs={docs}
                  templateName={templateName}
                  actions={actionFuncs}
                />
              );
            })
          }
        </div>
      );
    }
    if (showType === 'group') {
      const processedGroups = searchInput ? templateGroups.filter(R.compose(
        R.test(new RegExp(searchInput, 'i')),
        R.propOr('', 'groupName')
      )) : templateGroups;
      if (searchInput && isNilOrEmpty(processedGroups)) return <div style={{ minHeight: '400px', fontSize: '24px', textAlign: 'center', margin: '50px' }}>There are no files that matches your search.</div>;
      return (
        <div>
          {
            !processedGroups.length ? (
              <div style={{ padding: '24px', textAlign: 'center', fontSize: '20px' }}>
                You haven't create any template groups.
              </div>
            ) : <div/>
          }
          {
            processedGroups.map((group, i) => {
              const docs = R.filter(R.compose(R.contains(group._id), R.propOr([], 'templateGroups')), templates);
              return (<TemplateGroupBox
                key={i}
                router={router}
                allTemplates={R.filter(R.both(R.eqProps('startDate', group), R.eqProps('endDate', group)), templates)}
                templateGroup={group}
                childrenLength={docs.length}
                updateProps={updateProps}
                docs={docs}
                downloadPdfZip={downloadPdfZip}
                expanded={isTourRunning && i === 0}
              />);
            })
          }
          <EditGroupDialog updateProps={updateProps} />
        </div>
      );
    }
  };
  return (
    <div>
      <SearchNFilter
        route={route}
        updateFilters={payload => {
          router.replace({
            pathname: `/contracting/template-list`,
            query: {
              showType,
              searchInput,
              statusesFilter,
              searchingAllYears,
              ...payload,
            },
          });
        }}
        updateProps={updateProps}
        showType={showType}
        searchInput={searchInput}
        isSingleLoc={isSingleLoc}
        allContractPeriods={allContractPeriods}
        statusesFilter={statusesFilter}
        currentDocs={currentDocs}
        templates={templates}
      />
      {listRefreshing ? <CircularProgress style={{ marginLeft: '45%' }} /> : <span/>}
      {getContent()}
      <PublishDraftDialog/>
    </div>
  );
};

export default TemplateOrDraftList;



// WEBPACK FOOTER //
// ./src/app/components/contracting/template-list/list/list.jsx